import { getToken, clearAuth } from '../hooks/useAuth';

// 환경변수 기반
//  - 로컬 개발(.env.development): http://223.130.157.202:8000
//  - 배포(.env.production): 빈 값 = 상대경로 (Nginx 프록시 거침)
const API = process.env.REACT_APP_API_URL || '';

/**
 * apiFetch — 인증 헤더가 자동 추가되는 fetch 래퍼
 *
 * - Authorization: Bearer <token> 자동 첨부
 * - 401/402 응답 시 자동 로그아웃 처리
 *
 * 사용:
 *   const data = await apiGet('/api/stock/top-movers?market=all');
 *   const data = await apiPost('/api/stock/prices', ['005930']);
 */

async function apiFetch(path, options = {}) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const url = path.startsWith('http') ? path : `${API}${path}`;
  const res = await fetch(url, { ...options, headers });

  // 401: 인증 실패, 402: 구독 필요 → 자동 로그아웃
  if (res.status === 401 || res.status === 402) {
    clearAuth();
    throw new Error(res.status === 402 ? '구독이 만료되었습니다' : '인증이 필요합니다');
  }

  return res;
}

export async function apiGet(path) {
  const res = await apiFetch(path);
  return res.json();
}

export async function apiPost(path, body) {
  const res = await apiFetch(path, {
    method: 'POST',
    body: JSON.stringify(body),
  });
  return res.json();
}

export { API };
